import { render, staticRenderFns } from "./CustomerScopeNotice.html?vue&type=template&id=0708c395&scoped=true&external"
import script from "./CustomerScopeNotice.js?vue&type=script&lang=js&external"
export * from "./CustomerScopeNotice.js?vue&type=script&lang=js&external"
import style0 from "./CustomerScopeNotice.scss?vue&type=style&index=0&id=0708c395&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708c395",
  null
  
)

export default component.exports